import { jsx } from 'react/jsx-runtime';

function IndeterminateIcon() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "10",
      height: "2",
      viewBox: "0 0 10 2",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("path", { d: "M0 1H10", stroke: "white", strokeWidth: "2" })
    }
  );
}

export { IndeterminateIcon as default };
//# sourceMappingURL=IndeterminateIcon.mjs.map
